export const preLoadImage = async (src: string[]): Promise<boolean> => {
    await Promise.all(src.map((value) => {
        const img = new Image();
        img.src = value;
        return img.decode();
    }))
    console.log('preLoadImage completed!');
    return true;
}